import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Актуализирано:',
  breadcrumbs: {
    home: 'Начална страница',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Защо можете да ни се доверите',
        details: {
          text: '<h2>Защо можете да ни се доверите</h2><p>Статиите в Natu.Care са написани въз основа на научни изследвания, данни от правителствени сайтове и други надеждни източници. Текстовете са написани в сътрудничество с лекари, диетолози и други експерти в областта на здравето и красотата. Статиите се преглеждат преди публикуването им и при значителни актуализации.</p>',
          footerText: '<p>Научете повече за нашия <a href="/bg/za-nas/redakcionen-proces">редакционен процес</a></p>'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Informacja o reklamach',
        details: {
          text: '<h2>Информация за реклама</h2><p>Съдържанието на Natu.Care може да съдържа връзки към продукти, от продажбата на които можем да получим комисиона. При създаването на съдържанието се придържаме към високи редакционни стандарти и се стараем да бъдем обективни по отношение на обсъжданите продукти. Наличието на партньорски връзки не е продиктувано от нашите партньори, а продуктите, които разглеждаме, подбираме сами напълно независимо.</p>',
          footerText: '<p>Научете повече в нашите правила и <a href="/bg/reglamenti">условия</a></p>'
        }
      }
    ],
    tooltip: {
      labelVerified: 'Проверено от експерт',
      footerText: '<p>Научете повече за нашия <a href="/bg/za-nas/redakcionen-proces">редакционен процес</a></p>'
    }
  },

  mediabar: {
    heading: 'Медиите за нас:',
    href: '/bg/za-nas',
    title: 'За нас',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Осигуряване на здраво тяло',
    description: 'Опитайте висококачествените добавки на Natu.Care',
    button: {label: 'Преглед на продуктите', href: 'https://natu.shop/collections'},
    picture: {alt: 'Млади, красиви жени с добро състояние на кожата.'}
  },

  authorship: {
    heading: 'Редакция',
    link: {
      label: 'Запознайте се с екипа',
      href: '/bg/za-nas/redaktori'
    }
  },

  similarArticles: {
    headingBlogList: 'Статии',
    headingBlogPost: 'Подобни статии'
  }
};